import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
    return (
        <div className="page">
            <img src="/kaloai.png" alt="KaloAI" className="app-logo" />
            <h1>POLITYKA PRYWATNOŚCI KALOAI</h1>

            <p><Link to="/" className="router-link">← Powrót do strony głównej</Link></p>

            <p><strong>Data ostatniej aktualizacji: 15 stycznia 2025</strong></p>

            <h2>1. INFORMACJE OGÓLNE</h2>

            <p>Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych użytkowników
                aplikacji mobilnej KaloAI (dalej: "Aplikacja") udostępnianej przez BLONEKDEV (dalej: "my", "nas",
                "nasz").</p>

            <p>Szanujemy Twoją prywatność i zobowiązujemy się do ochrony Twoich danych osobowych zgodnie z
                obowiązującymi przepisami prawa, w tym Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z
                dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych
                (RODO).</p>

            <h2>2. DANE KONTAKTOWE ADMINISTRATORA</h2>

            <p><strong>Administrator danych:</strong></p>

            <ul>
                <li>Nazwa: BLONEKDEV</li>
                <li>Adres: ul. Mławka 25, Iłowo-Osada, Polska</li>
                <li>E-mail: blonekdev@gmail.com</li>
                <li>Telefon: +48 698404252</li>
            </ul>

            <h2>3. JAKIE DANE ZBIERAMY</h2>

            <h3>3.1 Dane konta i uwierzytelniania</h3>

            <p>Korzystamy z usługi Clerk do zarządzania kontami użytkowników. Zbieramy:</p>

            <ul>
                <li>Adres e-mail</li>
                <li>Imię i nazwisko (opcjonalnie)</li>
                <li>Unikalny identyfikator użytkownika</li>
                <li>Dane uwierzytelniania (tokeny sesji)</li>
            </ul>

            <h3>3.2 Dane zdrowotne i profilu</h3>

            <ul>
                <li>Wiek</li>
                <li>Płeć</li>
                <li>Wzrost i waga</li>
                <li>Poziom aktywności fizycznej</li>
                <li>Cele żywieniowe (utrata/przyrost/utrzymanie wagi)</li>
                <li>Dzienne cele kaloryczne i makroskładników</li>
            </ul>

            <h3>3.3 Dane żywieniowe</h3>

            <ul>
                <li>Zdjęcia posiłków</li>
                <li>Dzienniki żywienia</li>
                <li>Informacje o spożytych posiłkach</li>
                <li>Dane o kaloriach, białku, węglowodanach i tłuszczach</li>
                <li>Historia postępów i serie osiągnięć</li>
            </ul>

            <h3>3.4 Dane techniczne</h3>

            <ul>
                <li>Identyfikator urządzenia</li>
                <li>Token powiadomień push (Expo Push Notifications)</li>
                <li>Preferencje aplikacji i ustawienia</li>
                <li>Logi błędów i wydajności</li>
                <li>Metadane plików (przy przesyłaniu zdjęć)</li>
            </ul>

            <h3>3.5 Dane subskrypcji</h3>

            <ul>
                <li>Informacje o planie subskrypcji (miesięczny/roczny)</li>
                <li>Status subskrypcji</li>
                <li>Historia płatności (za pośrednictwem RevenueCat)</li>
                <li>Identyfikatory produktów i sklepów</li>
            </ul>

            <h2>4. JAK WYKORZYSTUJEMY TWOJE DANE</h2>

            <h3>4.1 Podstawowe funkcje aplikacji</h3>

            <ul>
                <li>Tworzenie i zarządzanie kontem użytkownika</li>
                <li>Analiza zdjęć żywności przy użyciu sztucznej inteligencji</li>
                <li>Śledzenie postępów żywieniowych</li>
                <li>Obliczanie spersonalizowanych celów żywieniowych</li>
                <li>Zarządzanie seriami osiągnięć</li>
            </ul>

            <h3>4.2 Komunikacja z użytkownikami</h3>

            <ul>
                <li>Wysyłanie powiadomień push o posiłkach i celach</li>
                <li>Powiadamianie o osiągnięciach i seriach</li>
                <li>Informowanie o statusie subskrypcji</li>
                <li>Wysyłanie powiadomień dotyczących bezpieczeństwa konta</li>
            </ul>

            <h3>4.3 Analiza i ulepszanie usług</h3>

            <ul>
                <li>Analiza sposobu korzystania z aplikacji</li>
                <li>Wykrywanie i naprawianie błędów</li>
                <li>Ulepszanie algorytmów analizy żywności</li>
                <li>Personalizacja doświadczenia użytkownika</li>
            </ul>

            <h3>4.4 Płatności i subskrypcje</h3>

            <ul>
                <li>Przetwarzanie płatności za subskrypcje Premium</li>
                <li>Zarządzanie dostępem do funkcji Premium</li>
                <li>Obsługa zwrotów i anulowań</li>
            </ul>

            <h2>5. PODSTAWY PRAWNE PRZETWARZANIA</h2>

            <p>Przetwarzamy Twoje dane osobowe na następujących podstawach prawnych:</p>

            <h3>5.1 Wykonanie umowy (art. 6 ust. 1 lit. b RODO)</h3>

            <ul>
                <li>Świadczenie usług aplikacji</li>
                <li>Zarządzanie kontem użytkownika</li>
                <li>Przetwarzanie płatności</li>
            </ul>

            <h3>5.2 Zgoda (art. 6 ust. 1 lit. a RODO)</h3>

            <ul>
                <li>Wysyłanie powiadomień push</li>
                <li>Analiza zdjęć żywności za pomocą AI</li>
                <li>Marketing bezpośredni</li>
            </ul>

            <h3>5.3 Prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO)</h3>

            <ul>
                <li>Zapewnienie bezpieczeństwa aplikacji</li>
                <li>Analiza sposobu korzystania z usług</li>
                <li>Ulepszanie jakości usług</li>
            </ul>

            <h2>6. UDOSTĘPNIANIE DANYCH OSOBOWYM</h2>

            <h3>6.1 Dostawcy usług zewnętrznych</h3>

            <p><strong>Clerk (Uwierzytelnianie)</strong></p>

            <ul>
                <li>Lokalizacja: Stany Zjednoczone</li>
                <li>Cel: Zarządzanie kontami użytkowników i uwierzytelnianie</li>
                <li>Podstawa: Wykonanie umowy</li>
                <li>Zabezpieczenia: Certyfikat SOC 2 Type II</li>
            </ul>

            <p><strong>OpenAI (Analiza zdjęć żywności)</strong></p>

            <ul>
                <li>Lokalizacja: Stany Zjednoczone</li>
                <li>Cel: Analiza zdjęć żywności przy użyciu AI (model GPT-4 Vision)</li>
                <li>Podstawa: Zgoda użytkownika</li>
                <li>Zabezpieczenia: Szyfrowanie danych, zgodność z przepisami o prywatności</li>
            </ul>

            <p><strong>Expo (Powiadomienia push)</strong></p>

            <ul>
                <li>Lokalizacja: Stany Zjednoczone</li>
                <li>Cel: Dostarczanie powiadomień push</li>
                <li>Podstawa: Zgoda użytkownika</li>
                <li>Zabezpieczenia: Szyfrowanie end-to-end</li>
            </ul>

            <p><strong>RevenueCat (Płatności)</strong></p>

            <ul>
                <li>Lokalizacja: Stany Zjednoczone</li>
                <li>Cel: Zarządzanie subskrypcjami i płatnościami</li>
                <li>Podstawa: Wykonanie umowy</li>
                <li>Zabezpieczenia: Zgodność z PCI DSS</li>
            </ul>

            <p><strong>MongoDB Atlas (Baza danych)</strong></p>

            <ul>
                <li>Lokalizacja: Unia Europejska (w zależności od konfiguracji)</li>
                <li>Cel: Przechowywanie danych aplikacji</li>
                <li>Podstawa: Wykonanie umowy</li>
                <li>Zabezpieczenia: Szyfrowanie danych w spoczynku i transmisji</li>
            </ul>

            <h3>6.2 Organy publiczne</h3>

            <p>Możemy udostępnić Twoje dane organom publicznym wyłącznie w przypadkach przewidzianych przez prawo.</p>

            <h2>7. MIĘDZYNARODOWE PRZEKAZYWANIE DANYCH</h2>

            <p>Niektórzy z naszych dostawców usług mają siedziby poza Europejskim Obszarem Gospodarczym (EOG). W takich
                przypadkach stosujemy odpowiednie zabezpieczenia:</p>

            <ul>
                <li><strong>Stany Zjednoczone</strong>: Współpracujemy z firmami objętymi ramami ochrony danych UE-USA
                    lub stosujemy standardowe klauzule umowne zatwierdzone przez Komisję Europejską</li>
                <li><strong>Inne kraje</strong>: Stosujemy decyzje o adekwatności lub standardowe klauzule umowne</li>
            </ul>

            <h2>8. BEZPIECZEŃSTWO DANYCH</h2>

            <p>Stosujemy zaawansowane środki bezpieczeństwa techniczne i organizacyjne:</p>

            <h3>8.1 Zabezpieczenia techniczne</h3>

            <ul>
                <li>Szyfrowanie danych w transmisji (HTTPS/TLS)</li>
                <li>Szyfrowanie danych w spoczynku</li>
                <li>Regularne aktualizacje bezpieczeństwa</li>
                <li>Monitoring dostępu do danych</li>
                <li>Bezpieczne przechowywanie tokenów uwierzytelniania</li>
            </ul>

            <h3>8.2 Zabezpieczenia organizacyjne</h3>

            <ul>
                <li>Ograniczony dostęp do danych osobowych</li>
                <li>Regularne szkolenia personelu</li>
                <li>Procedury reagowania na incydenty</li>
                <li>Okresowe audyty bezpieczeństwa</li>
            </ul>

            <h2>9. OKRES PRZECHOWYWANIA DANYCH</h2>

            <h3>9.1 Aktywni użytkownicy</h3>

            <ul>
                <li>Dane konta: Do czasu usunięcia konta</li>
                <li>Dane żywieniowe: Ostatnie 30 dni (z możliwością eksportu)</li>
                <li>Dane preferencji: Do czasu zmiany przez użytkownika</li>
            </ul>

            <h3>9.2 Nieaktywni użytkownicy</h3>

            <ul>
                <li>Automatyczne usuwanie konta po 24 miesiącach bezczynności</li>
                <li>Wcześniejsze powiadomienie o planowanym usunięciu</li>
            </ul>

            <h3>9.3 Dane po usunięciu konta</h3>

            <ul>
                <li>Całkowite usunięcie w ciągu 30 dni</li>
                <li>Zachowanie niektórych danych w celach prawnych (zgodnie z przepisami)</li>
            </ul>

            <h2>10. TWOJE PRAWA</h2>

            <p>Zgodnie z RODO przysługują Ci następujące prawa:</p>

            <h3>10.1 Prawo dostępu (art. 15 RODO)</h3>

            <p>Możesz żądać informacji o przetwarzaniu Twoich danych osobowych.</p>

            <h3>10.2 Prawo do sprostowania (art. 16 RODO)</h3>

            <p>Możesz żądać poprawienia nieprawidłowych danych.</p>

            <h3>10.3 Prawo do usunięcia (art. 17 RODO)</h3>

            <p>Możesz żądać usunięcia danych w określonych przypadkach.</p>

            <h3>10.4 Prawo do ograniczenia przetwarzania (art. 18 RODO)</h3>

            <p>Możesz żądać ograniczenia przetwarzania w określonych sytuacjach.</p>

            <h3>10.5 Prawo do przenoszenia danych (art. 20 RODO)</h3>

            <p>Możesz otrzymać swoje dane w ustrukturyzowanym formacie.</p>

            <h3>10.6 Prawo do sprzeciwu (art. 21 RODO)</h3>

            <p>Możesz sprzeciwić się przetwarzaniu na podstawie prawnie uzasadnionego interesu.</p>

            <h3>10.7 Prawo do cofnięcia zgody</h3>

            <p>Możesz w każdej chwili cofnąć zgodę na przetwarzanie danych.</p>

            <h3>10.8 Sposób wykonywania praw</h3>

            <p>Aby skorzystać ze swoich praw, skontaktuj się z nami:</p>

            <ul>
                <li>E-mail: blonekdev@gmail.com</li>
                <li>W aplikacji: Ustawienia → Prywatność i bezpieczeństwo</li>
            </ul>

            <h2>11. POWIADOMIENIA PUSH</h2>

            <h3>11.1 Rodzaje powiadomień</h3>

            <ul>
                <li>Przypomnienia o posiłkach</li>
                <li>Powiadomienia o osiągnięciach</li>
                <li>Aktualizacje serii</li>
                <li>Informacje o subskrypcji</li>
            </ul>

            <h3>11.2 Zgoda i rezygnacja</h3>

            <ul>
                <li>Możesz włączyć/wyłączyć powiadomienia w ustawieniach aplikacji</li>
                <li>Możesz wybrać rodzaje powiadomień, które chcesz otrzymywać</li>
                <li>Rezygnacja jest możliwa w każdej chwili</li>
            </ul>

            <h2>12. DZIECI I MŁODZIEŻ</h2>

            <p>Aplikacja nie jest przeznaczona dla osób poniżej 16. roku życia. Nie zbieramy świadomie danych osobowych
                od dzieci. Jeśli dowiadujemy się, że zebraliśmy dane dziecka, niezwłocznie je usuniemy.</p>

            <h2>13. ZMIANY W POLITYCE PRYWATNOŚCI</h2>

            <p>Możemy aktualizować niniejszą Politykę Prywatności. O istotnych zmianach powiadomimy Cię:</p>

            <ul>
                <li>Przez powiadomienie w aplikacji</li>
                <li>E-mailem (jeśli wyrazisz na to zgodę)</li>
                <li>Poprzez publikację nowej wersji w App Store</li>
            </ul>

            <p>Zalecamy regularne sprawdzanie tej strony w celu zapoznania się z aktualnymi informacjami o naszych
                praktykach w zakresie prywatności.</p>

            <h2>14. KONTAKT W SPRAWACH PRYWATNOŚCI</h2>

            <p>W przypadku pytań dotyczących tej Polityki Prywatności lub przetwarzania Twoich danych osobowych,
                skontaktuj się z nami:</p>

            <p><strong>E-mail</strong>: blonekdev@gmail.com<br />
                <strong>Adres</strong>: ul. Mławka 25, Iłowo-Osada, Polska
            </p>

            <h2>15. ORGAN NADZORCZY</h2>

            <p>Masz prawo do złożenia skargi do organu nadzorczego:</p>

            <ul>
                <li><strong>Urząd Ochrony Danych Osobowych</strong></li>
                <li>ul. Stawki 2, 00-193 Warszawa</li>
                <li>Telefon: 22 531 03 00</li>
                <li>E-mail: kancelaria@uodo.gov.pl</li>
            </ul>

            <h2>16. PLIKI COOKIES I TECHNOLOGIE ŚLEDZĄCE</h2>

            <h3>16.1 Rodzaje wykorzystywanych technologii</h3>

            <ul>
                <li>Lokalne przechowywanie danych (AsyncStorage)</li>
                <li>Tokeny sesji uwierzytelniania</li>
                <li>Identyfikatory analityczne</li>
            </ul>

            <h3>16.2 Cele wykorzystania</h3>

            <ul>
                <li>Utrzymywanie sesji użytkownika</li>
                <li>Zapisywanie preferencji aplikacji</li>
                <li>Analiza wydajności aplikacji</li>
            </ul>

            <h3>16.3 Zarządzanie</h3>

            <p>Możesz zarządzać danymi lokalnymi poprzez:</p>

            <ul>
                <li>Ustawienia aplikacji</li>
                <li>Wylogowanie się z konta</li>
                <li>Odinstalowanie aplikacji</li>
            </ul>

            <hr />

            <p><strong>Ostatnia aktualizacja</strong>: 15 stycznia 2025<br />
                <strong>Wersja</strong>: 1.0
            </p>

            <p>Zachęcamy do zapoznania się z naszymi Warunkami Świadczenia Usług, które uzupełniają niniejszą Politykę
                Prywatności.</p>
        </div>
    );
};

export default PrivacyPage;